import React from 'react';
import * as R from 'ramda';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { MDropdown } from 'common';
import {
  ANY_VALUE,
  AUTH_SEQUENCING_LOADING_ALLOWED_FILTER_OPTIONS,
} from 'feature/loading-management/utils/const';

// Utils
import { capitalize } from 'utils/helpers/format';

const Filters = ({
  cancelButtonStyles,
  cardType,
  filters: { loadingAllowed, nameShort, state },
  handleClose,
  lgUp,
  productOrLocationOptions,
  resetCardFilters,
  setFilters,
  stateOptions,
}) => {
  const showClear = R.o(R.not, R.all(R.equals(ANY_VALUE)))([loadingAllowed, nameShort, state]);

  return (
    <>
      {!lgUp && (
        <>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5">Filters</Typography>
            <IconButton onClick={handleClose} size="large" sx={cancelButtonStyles}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Divider />
        </>
      )}
      {productOrLocationOptions.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="product-or-location-select"
          items={productOrLocationOptions}
          label={capitalize(cardType)}
          name="nameShort"
          onChange={setFilters}
          value={nameShort}
        />
      )}
      {stateOptions.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="state-select"
          items={stateOptions}
          label="State"
          name="state"
          onChange={setFilters}
          value={state}
        />
      )}
      <MDropdown
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        id="loading-allowed-select"
        items={AUTH_SEQUENCING_LOADING_ALLOWED_FILTER_OPTIONS}
        label="Status"
        name="loadingAllowed"
        onChange={setFilters}
        value={loadingAllowed}
      />
      {showClear && (
        <Button onClick={() => resetCardFilters()} sx={{ mx: 'auto', my: 1 }} variant="text">
          Clear
        </Button>
      )}
    </>
  );
};

Filters.propTypes = {
  cancelButtonStyles: shape({}).isRequired,
  cardType: string.isRequired,
  filters: shape({
    loadingAllowed: string.isRequired,
    nameShort: string.isRequired,
    state: string.isRequired,
  }).isRequired,
  handleClose: func.isRequired,
  lgUp: bool.isRequired,
  productOrLocationOptions: arrayOf(shape({})).isRequired,
  resetCardFilters: func.isRequired,
  setFilters: func.isRequired,
  stateOptions: arrayOf(shape({})).isRequired,
};

export default Filters;
